export const DOM_CANCELATION_INSURANCE = 'DOM_CANCELATION_INSURANCE'
export const INTL_CANCELATION_INSURANCE = 'INTL_CANCELATION_INSURANCE'
export const STANDARD_FARE = 'STANDARD_FARE'
export const AMEND_INSURANCE = 'AMEND_INSURANCE'
export const REGULAR_FARE = 'REGULAR_FARE'
export const BUSINESS_FARE = 'BUSINESS_FARE'
export const FLEXI_PLUS = 'REGULAR_FARE_FLEXIPLUS'
export const REGULAR_FARE_SUPER6E = 'REGULAR_FARE_SUPER6E'
